export const GET_PAYMENT_PRODUCTS_REQUEST = 'GET_PAYMENT_PRODUCTS_REQUEST';
export const GET_PAYMENT_PRODUCTS_SUCCESS = 'GET_PAYMENT_PRODUCTS_SUCCESS';
export const GET_PAYMENT_PRODUCTS_FAIL = 'GET_PAYMENT_PRODUCTS_FAIL';
export const GET_PAYMENT_PRODUCTS_RESET = 'GET_PAYMENT_PRODUCTS_RESET';
